export class InvalidCredentialsError extends Error {
    constructor(error: Error) {
        super(error.message)
        this.cause = error.cause
        this.name = "InvalidCredentialsError"
        Object.setPrototypeOf(this, InvalidCredentialsError.prototype)
    }
}
